import { render, staticRenderFns } from "./PagespeedAuditMetricItem.vue?vue&type=template&id=774f8123&"
import script from "./PagespeedAuditMetricItem.vue?vue&type=script&lang=js&"
export * from "./PagespeedAuditMetricItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports